import 'vue/jsx';

// 引入windi css
import '@/plugins/unocss';

// 导入全局的svg图标
import '@/plugins/svgIcon';

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n';

// 引入状态管理
import { setupStore } from '@/store';

// 全局组件
import { setupGlobCom } from '@/components';

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus';

// 引入全局样式
import '@/styles/index.less';
// 字体覆盖放在最后，并配合 !important，避免 EP 按需注入样式覆盖 :root 变量
import '@/styles/theme-font-override.css';

// 引入动画
import '@/plugins/animate.css';

// 路由
import { setupRouter } from './router';

// 权限
import { setupPermission } from './directives';

import { createApp } from 'vue';

import App from './App.vue';

import './permission';

import { initPlug } from '@/utils/editor';

import Viewer from 'v-viewer';

// 引入打印插件
import print from 'vue3-print-nb';

// 注册富文本，自定义插件注释
initPlug();

// 创建实例
const setupAll = async () => {
  const app = createApp(App);

  await setupI18n(app);

  setupStore(app);

  setupGlobCom(app);

  setupElementPlus(app);

  setupRouter(app);

  setupPermission(app);

  app.use(Viewer);

  // 注册打印插件
  app.use(print);

  app.mount('#app');
};

setupAll();
